'use strict';

import $ from 'jquery';

export default class SelectClone {
	constructor() {
		$('.custom-select select').map((i, ele) => {
			let $this = $(ele),
				$option = $('option', $this);

			$this.wrap('<div class="select-clone-pair"></div>');

			let firstOption = $('option', $this).first().text(),
				firstValue = $('option', $this).first().val(),
				_clone = `<div class="select-clone"><button type="button" value="${firstValue}">${firstOption}</button><i class="icon-chevron-down"></i><ul class="dropdown-clone"></ul></div>`;

			// Append dropdown and button clone
			$this.before(_clone);

			// Generate dropdown from options
			$option.each(function(){
				let text = $(this).text(),
					value = '';

				if ($(this).attr('value')) {
					value = $(this).attr('value');
				}

				$('.dropdown-clone', $this.parent()).append(`<li><a href="#" data-value="${value}"><span>${text}</span></a></li>`);
			});
		});


		let $copyPair = $('.select-clone-pair');

		$copyPair.map((i,ele) => {
			let $thisPair = $(ele),
				$copy = $('.select-clone', $thisPair),
				$button = $('button', $thisPair),
				$icon = $('.icon-chevron-down', $thisPair),
				$dropdown = $('.dropdown-clone', $thisPair),
				$select = $('select', $thisPair);

			$button.on('click', (e) => {
				e.preventDefault();
				e.stopPropagation();

				if (!$copy.hasClass('active')){
					$copy.addClass('active');
				}
				else {
					$copy.removeClass('active');
				}

				$('.select-clone').not($copy).removeClass('active');
			});

			$icon.on('click', (e) => {
				e.stopPropagation();
				$button.trigger('click');
			});

			$('li a', $dropdown).on('click', function(e){
				e.preventDefault();

				let value = $(this).data('value'),
					text = $(this).text();

				$button.text(text);
				$select.val(value);
				// console.log($select.val());
			});
		});

		$(window).on('click', () => {
			if ($('.select-clone', $copyPair).hasClass('active')){
				$('.select-clone', $copyPair).removeClass('active');
			}
		});
	}
}
